export class RoutePaths {
  static survey = '/';
  static privacyPolicy = '/policy';
  static regulations = '/regulations';
  static legalNotice = '/legalnotice';
  static about = '/about';
}
